import { render, staticRenderFns } from "./jobCardBlockKanban.vue?vue&type=template&id=3e9df5c6"
import script from "./jobCardBlockKanban.vue?vue&type=script&lang=js"
export * from "./jobCardBlockKanban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports